import * as Types from '../../declarations'
// import PictureGrid from './components/PictureGrid'
import SectionHeader from './components/SectionHeader'
import HTMLContent from 'components/HTMLContent'

interface Props {
	trip: Types.DB.Models.TripAttributes
}

const Accomodation = ({
	trip: {
		name,
		jsonData: { accommodation, trekOrClimb },
	},
}: // trip,
Props) => {
	const isTrekNotPeak = trekOrClimb === 'TREK'
	if (!accommodation?.description || !isTrekNotPeak) return <></>

	// const defaultAltText = getTrekImageAltText(trip, 'accommodation')

	return (
		<div id="accommodation-wrapper" className="spacing-between-sections-above">
			<SectionHeader
				title={`${name} Accomodation`}
				subtitle={`What is the accommodation like ${
					trekOrClimb === Types.App.DataTypes.TrekOrClimb.TREK
						? 'treking'
						: 'climbing'
				} ${name}`}
				section={Types.App.DataTypes.FeedbackSection.ACCOMMODATION}
			/>
			{accommodation.description && (
				<HTMLContent
					id="accommodation-description"
					html={accommodation.description}
				></HTMLContent>
			)}
			{/* disabling pictures for now until we have a solution for more legit
			pictures */}
			{/* {accommodation.pictures && (
				<PictureGrid
					pictures={accommodation.pictures}
					defaultAltText={defaultAltText}
				/>
			)} */}
		</div>
	)
}

export default Accomodation
